import React from 'react'
import { useSelector } from 'react-redux';
import { MessageType, userType } from '../../../../constants/General';
import defaultProfile from '../../../../assets/Icons/default-profile.svg';
import { Actions } from '../../../../store/actions';
import { showMessage } from '../../../../utils/utility/snackbar';
import { dispatch } from '../../../../utils/utility/store';
import { UNSAVED_CHANGES_MESSAGE } from '../../../constants';
import ProptechCardLabel from '../../ProptechCardLabel';
import { Chip } from '@mui/material';

export default function ContactCard(props) {
  //  **** props ****
  const { contact, unsaveChange } = props

  // Store
  const { isContactSelected, selectedContact } = useSelector(state => state.adminContacts);

  const handleSelected = () => {
    dispatch(Actions.Contacts.SetAlreadySelectedContact, null)
    if (!unsaveChange.current) {
      let isSelected = selectedContact?.id !== contact.id && selectedContact?.userType !== contact.userType ? true : !isContactSelected
      dispatch(Actions.Contacts.SetIsSelectedContact, isSelected)
      if (contact.id === selectedContact?.id && selectedContact?.userType === contact.userType) {
        dispatch(Actions.Contacts.SetIsSelectedContact, false)
        dispatch(Actions.Contacts.SetSelectedContact, null)
      } else {
        dispatch(Actions.Contacts.SetSelectedContact, contact)
      }
    } else {
      showMessage(UNSAVED_CHANGES_MESSAGE.message, MessageType.Error)
    }
  }

  const getContactCardColor = (type) => {
    switch(type) {
      case 2:
        return '#111D43'
      case 3:
        return '#FF4100'
      case 4:
        return '#39B54A'
      case 5:
        return '#009BE2'
      default:
        return '#70778E'
    }
  }

  return (
    <>
      <div className='border-solid border-t border-[#111D43] opacity-40' />
      <div
        id={`contact-${contact?.id}`}
        className={`w-full cursor-pointer ${selectedContact?.id === contact.id && selectedContact?.userType === contact.userType ? `bg-[#E7E8EC]` : `bg-[#FFFFFF]`}
      `}
        onClick={() => handleSelected()}
      >
        <div className='proptech-tab-heading'>
          <div className='flex box-border items-center '>
            <div className='profile-img mr-[15px] w-[35px] h-[35px] xlg:h-[46px] xlg:w-[46px] rounded-full min-w-[35px] xlg:min-w-[46px]'>
              <img
                src={contact?.profileImage || defaultProfile}
                className="rounded-full bg-[#70778E] h-full w-full object-cover"
                alt="Profile"
              />
            </div>
            <div className='grow'>
              <div className='flex justify-between'>
                <span className='font-medium text-sm leading-5 not-italic text-[#111D43]'>{contact.name}</span>
              </div>
              <ProptechCardLabel
                header="Company name"
                className={`xlg:min-w-[104px] has-direction-row`}
                label={contact?.companyName || '-'}
                style={{ marginRight: '4px' }} 
              />
              <Chip label={contact?.userType} sx={{color: "#ffffff", fontSize: 12, height: 20,  backgroundColor: getContactCardColor(userType[contact?.userType?.toLowerCase()])}}/>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
